module.exports = __webpack_public_path__ + "img/users-edit.0c2b37fe.svg";